import ArticleCard from "pages/content/article/ArticleCard";
import { ArticleType } from "types/ArticleType";
import "./ListOfCard.scss";

const ListOfCard = ({ data, title }: any) => {
  return (
    <div className="List-Of-Card">
      <h2 className="Page-Title">{title}</h2>
      <div className="List-Of-Card-Container">
        {data.list.map((article: ArticleType, id: number) => {
          return (
            <div className="List-Of-Card-Item" key={article.article_slug}>
              <ArticleCard article={article} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default ListOfCard;
